import React from "react";
import {Check} from "./check";
import "./stepper.css";

export interface StepItemProps {
  number: number;
  status: string;
  title: string;
}

export const StepItem = ({number, status, title}: StepItemProps) => {
  const displayInfo = status === "completed" ? <Check /> : number;
  return (
    <div
      className={`stepper-title node relative flex flex-1 flex-col items-center ${status}`}
    >
      <span>{title}</span>
      <span className="item-icon flex items-center justify-center rounded-full border-0 bg-gray-300">
        {displayInfo}
      </span>
    </div>
  );
};
